import { gql } from '@apollo/client';

export const SAVE_TRAFFICKING_FILTERS = gql`
  mutation SaveTraffickingFilters($input: TraffickingFiltersInput!) {
    saveTraffickingFilters(input: $input) {
      id
    }
  }
`;
